import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Avatar = ({ name, src }) => {
  const initials = (name || "You")
    .split(" ")
    .map((p) => p[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();

  const isValidSrc = src && typeof src === "string" && src.trim().length > 5;

  return (
    <div className="relative">
      <span
        className="pointer-events-none absolute -inset-1 rounded-2xl
                   bg-gradient-to-tr from-fuchsia-300/30 via-sky-300/25 to-emerald-300/30
                   blur-lg animate-pulse"
        aria-hidden
      />
      {isValidSrc ? (
        <img
          src={src}
          alt={name || "Profile"}
          onError={(e) => {
            // fallback if image fails to load
            e.currentTarget.style.display = "none";
            e.currentTarget.insertAdjacentHTML(
              "afterend",
              `<div class="relative h-12 w-12 rounded-2xl bg-neutral-100 text-gray-700 grid place-items-center text-base font-semibold ring-1 ring-black/5">${initials}</div>`
            );
          }}
          className="relative h-12 w-12 rounded-2xl object-cover ring-1 ring-black/5"
        />
      ) : (
        <div className="relative h-12 w-12 rounded-2xl bg-neutral-100 text-gray-700 grid place-items-center text-base font-semibold ring-1 ring-black/5">
          {initials}
        </div>
      )}
    </div>
  );
};


const AdminProfileIcon = ({ user, onOpenSettings }) => {
  const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const [profileImage, setProfileImage] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      const email = localStorage.getItem("userEmail");
      const token = localStorage.getItem("token");
      if (!email || !token) return;

      try {
        const res1 = await fetch(`${BACKEND_URL}/user/${email}/profile-image`);
        const img = await res1.json();
        if (img?.profileImage) setProfileImage(img.profileImage);

        const res2 = await fetch(`${BACKEND_URL}/user/${email}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const user = await res2.json();
        setFirstName(user.firstName || "");
        setLastName(user.lastName || "");
      } catch (e) {
        console.error("❌ Fetch error:", e);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const closeOnOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", closeOnOutside);
    return () => document.removeEventListener("mousedown", closeOnOutside);
  }, []);

  const handleSignOut = () => {
    localStorage.clear();
    navigate("/login");
  };

  const handleProfileClick = () => {
    const email = localStorage.getItem("userEmail");
    if (email) {
      const username = email.split("@")[0];
      navigate(`/${username}/profile`);
    }
  };

  const handleNavigateTo = (path) => {
    const username = localStorage.getItem("username");
    if (!username) return;
    navigate(`/${username}/${path}`);
    setShowDropdown(false);
  };

  const fullName = `${firstName} ${lastName}`.trim();

  return (
    <div ref={dropdownRef} className="relative z-[999]">
      <div className="flex items-center gap-2">
        {/* <div className="hidden sm:flex flex-col text-right">
          <div className="text-slate-900 text-base font-normal leading-none">
            {firstName} {lastName}
          </div>
        </div> */}

        <div
          onClick={() => setShowDropdown((prev) => !prev)}
          className="cursor-pointer"
        >
          {/* ✅ Use same Avatar style as BuilderCard */}
          <Avatar name={fullName || "User"} src={profileImage} />
        </div>
      </div>

      {showDropdown && (
        <div className="absolute right-0 top-full mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-xl overflow-hidden">
          <button
            onClick={handleProfileClick}
            className="block w-full text-left px-4 py-2 text-sm text-gray-800 hover:bg-gray-100"
          >
            View Account
          </button>
          <button
            onClick={() => handleNavigateTo("notifications")}
            className="block w-full text-left px-4 py-2 text-sm text-gray-800 hover:bg-gray-100 flex justify-between items-center"
          >
            Notifications
            {unreadCount > 0 && (
              <span className="ml-2 inline-flex items-center justify-center px-2 py-0.5 text-xs font-medium text-white bg-red-500 rounded-full">
                {unreadCount}
              </span>
            )}
          </button>
          <button
            onClick={() => handleNavigateTo("invites")}
            className="block w-full text-left px-4 py-2 text-sm text-gray-800 hover:bg-gray-100"
          >
            Invites
          </button>
          <button
            onClick={() => {
              setShowDropdown(false);
              onOpenSettings?.();
            }}
            className="block w-full text-left px-4 py-2 text-sm text-gray-800 hover:bg-gray-100"
          >
            Settings
          </button>
          <button
            onClick={handleSignOut}
            className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
          >
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};

export default AdminProfileIcon;
